import { render, staticRenderFns } from "./organauthstart.vue?vue&type=template&id=1893a9a0&scoped=true"
import script from "./organauthstart.vue?vue&type=script&lang=js"
export * from "./organauthstart.vue?vue&type=script&lang=js"
import style0 from "./organauthstart.vue?vue&type=style&index=0&id=1893a9a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1893a9a0",
  null
  
)

export default component.exports